import type { ReferralCode } from '@polaris/core/services'
import { useState } from 'react'
import { getQueryClient } from '@/src/configs/tanstack-query'
import { useGetReferrerProfile } from '@/src/queries/hooks/referralcodes'
import { getReferrerProfileQuery } from '@/src/queries/keys/referralcodes'
import { CreateReferralCode } from './create-referral-code'
import { ShowReferralCode } from './show-referral-code'

export const ReferralsScreen = () => {
  const [createdCode, setCreatedCode] = useState<ReferralCode | null>(null)

  // Get existing referral code for the user
  const { data: referrerProfile, isLoading } = useGetReferrerProfile()

  const handleCreateSuccess = (referralCode: ReferralCode) => {
    // Invalidate the referral code query to get the latest data
    getQueryClient().invalidateQueries(getReferrerProfileQuery)
    setCreatedCode(referralCode)
  }

  // Show loading state while checking for existing code
  if (isLoading) {
    return (
      <div className='flex flex-col items-center justify-center h-64'>
        <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-primary' />
        <p className='mt-4 text-secondary'>Loading...</p>
      </div>
    )
  }

  // If user has an existing code or just created one, show it
  const referralCode =
    createdCode?.referral_code || referrerProfile?.referral_code
  const referredUsersCount = referrerProfile?.referred_users_count ?? 0

  if (referralCode) {
    return (
      <ShowReferralCode
        referralCode={referralCode}
        referredUsersCount={referredUsersCount}
      />
    )
  }

  // If no existing code (404 error is expected), show create screen
  return <CreateReferralCode onSuccess={handleCreateSuccess} />
}
